<template>
  <div class="schedule-wrap container flex">
    <div class="schedule-item schedule-info">
      <div class="title">
        <span>{{ langSet == 'cn'? '展览与活动时间' : 'Exhibition and Event Schedule'}} </span>
      </div>
      <img
        class="home-exhibition-time"
        :src="
          langSet == 'cn'
            ? require('../../../assets/imgs/schedule_cn.png')
            : require('../../../assets/imgs/schedule_en.png')
        "
        alt=""
      />
    </div>
    <div class="schedule-item schedule-swiper">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="item in list"
          :key="item.id"
          :data-id="item.id"
        >
          <img :src="langSet == 'cn' ? item.image : item.en_image" alt />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper"; // 注意引入的是Swiper
import "../../../../node_modules/swiper/css/swiper.min.css"; //
export default {
  props: {
    webData: Object,
    list: Array,
  },
  components: {},
  data() {
    return {
      langSet: "",
    };
  },
  mounted() {
    this.langSet = this.$language;
    let that = this;
    setTimeout(() => {
      that.mySwiper = new Swiper(".schedule-swiper", {
        spaceBetween: 0,
        loop: true,
        autoplay:
          this.list.length > 1
            ? {
                dealy: 3000,
                disableOnInteraction: false,
              }
            : false,
        on: {
          tap: function (swiper, event) {
            const realIndex = that.mySwiper.realIndex;
            const item = that.list[realIndex];
            that.toLink(item);
          },
        },
      });
    }, 300);
  },
  methods: {
    toLink(item, index) {
      if (item.url_type == 1) {
        this.$router.push({
          path: this.langSet == "cn" ? item.url : item.en_url,
        });
      } else if (item.url_type == 2) {
        window.open(this.langSet == "cn" ? item.url : item.en_url, "_blank");
      }
    },
  },
  beforeDestroy() {
    if (this.mySwiper) {
      this.mySwiper.destroy(true, true);
      this.mySwiper = null; // 释放内存引用
    }
  },
};
</script>
<style lang="scss" scoped>
.schedule-wrap {
  margin: 67px auto 120px;
  gap: 40px;
  justify-content: space-between;
  .schedule-item {
    width: calc((100% - 40px) / 2);
    height: 286px;
    .home-exhibition-time {
      width: 100%;
      margin-top: 30px;
    }
  }
  .schedule-info {
    padding: 15px 50px;
    box-sizing: border-box;
    background: url("../../../assets/imgs/schedule_bg.png") no-repeat;
    background-size: 100% 100%;
    .title {
      font-weight: 600;
      font-size: 24px;
      color: #ffffff;
      line-height: 33px;
      position: relative;
      span {
        position: relative;
        z-index: 2;
      }
      &::after {
        content: "";
        position: absolute;
        top: -42px;
        left: -20px;
        width: 112px;
        height: 88px;
        background: url("../../../assets/imgs/schedule_icon.png") no-repeat;
        background-size: 100%;
      }
    }
  }
  .schedule-swiper {
    overflow: hidden;
    border-radius: 100px 100px 100px 0px;
    .swiper-wrapper {
      // display: flex;
      position: relative;
      width: 100%;
      height: 100%;
      z-index: 1;
      display: flex;
      flex-wrap: nowrap;
      transition-property: transform;
      box-sizing: content-box;
    }
    .swiper-slide {
      width: 100% !important;
      text-align: center;
      font-size: 18px;
      background: #fff;
      cursor: pointer;

      /* Center slide text vertically */
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      // -webkit-justify-content: center;
      // justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}
@media only screen and (max-width: 1280px) {
}
@media only screen and (max-width: 767px) {
  .schedule-wrap {
    gap: 0;
    flex-wrap: wrap;
    margin: 0.6rem auto;
    .schedule-item {
      width: 100%;
      height: 3rem;
      padding: 10px 30px;
      margin-bottom: 0.3rem;
      .home-exhibition-time {
        margin-top: 0;
      }
    }
    .schedule-info {
      .title {
        font-size: 0.3rem;
        &::after {
          width: 75px;
          top: -28px;
        }
      }
    }
    .schedule-swiper {
      padding: 0;
      border-radius: 60px 60px 60px 0px;
    }
  }
}
</style>